/**
 * 获取列表界面的搜索项
 */
export function getSearchData(flag) {
    let data = []
    switch (flag) {
        case "question":
            // 题库
            data = [{
                    title: "科目",
                    type: "selects",
                    value: [],
                    key: "subject",
                    options: []
                },
                {
                    title: "题型",
                    type: "select",
                    value: "",
                    key: "topicnType",
                    options: [ // 0 单选  1 多选 2 填空  3 判断  4 简答  5 实操

                    ]
                },
            ]
            break;
        case "subject":
            // 科目
            data = [{
                title: "科目名称",
                type: "input",
                value: "",
                key: "name",
            }, ]
            break

        default:
            break;
    }
    return data
}
/**
 * 获取界面搜索框旁边的按钮
 * @param {*} flag  标识哪个界面
 */
export function getTopButArray(flag) {
    let data = []
    switch (flag) {
        case "question":
            // 题库列表
            data = [
                { name: "新增题库", active: "create", icon: "el-icon-plus" },
                { name: "题库导入", active: "import", icon: "el-icon-upload" },
            ]
            break;
        case "subject":
            // 科目列表
            data = [
                { name: "新增科目", active: "create", icon: "el-icon-plus" },
            ]
            break;
        default:
            break;
    }
    return data
}
/**
 * 获取题库列表表头数据
 */
export function getQuestionTableMenu() {
    return [
        { name: "题干", key: "questionStem", isStar: false, isHtml: true, width: 430 },
        { name: "科目", key: "subject", isStar: false },
        { name: "题目类型", key: "topicnType", isStar: false },
        // { name: "题库类型", key: "questionType", isStar: false },
        { name: "难度", key: "gradeOfDifficulty", isStar: true, sort: "custom" },
        { name: "知识点", key: "knowledgePoint", isStar: false },
    ]
}

/**
 * 模拟题库列表数据
 */
export function initTableData() {
    return [
        { id: "111", subject: "计算机", type: "选择题", level: "考试题", star: 4, creater: "张三", knowledgePoint: "" }
    ]
}

/**
 * 获取表格操作按钮
 * @param {*} flag  表示当前为哪个界面的
 */
export function getTableBUttonList(flag) {
    switch (flag) {
        case "question":
            // 题库
            return [
                { text: "编辑", active: "edit_question" },
                { text: "删除", active: "delete_question" },
            ]
            break;
        case "subject":
            // 科目
            return [
                { text: "编辑", active: "edit_subject" },
                { text: "删除", active: "delete_subject" },
            ]
            break;

        default:
            break;
    }
}

/**
 * 判断编辑器中是否有填空题选项 
 * @param {*} content  编辑器中返回的数据
 */
export function questionItemReset(content) {
    let spanRegex = new RegExp(
        '<span class="gapfilling-span(.*?)">(.*?)<\\/span>',
        "g"
    );
    let _this = this;
    let newFormItem = [];
    let gapfillingItems = content.match(spanRegex);
    if (gapfillingItems === null) {
        return [];
    }
    gapfillingItems.forEach(function(span, index) {
        let pairRegex = /<span class="gapfilling-span(.*?)">(.*?)<\/span>/;
        pairRegex.test(span);
        newFormItem.push({
            id: null,
            itemUuid: RegExp.$1, // 当前空挡对应的uuid
            title: RegExp.$2, //当前空挡对应的数字
            value: "",
        });
    });

    return newFormItem
}

/**
 * 返回提交题库时,数据需要的数据
 * @param {*} object  界面显示数据
 * 
        id: "",
        subject: [], // 科目
        scaleMarks: "0", // 评分标准
        topicnType: "0", // 题目类型
        questionType: "0", // 题库类型
        questionStem: "", // 题干
        questionOptions: [], // 单选和多选的选项组
        questionAnswer: [], // 答案
        knowledgePoint: "", // 相关知识点
        gradeOfDifficulty: 1, // 难度
 */
export function returnInterfaceData(object) {
    let data = {}
    return data
}


/**
 * 获取弹出框的界面布局数据
 * @param {*} active 对应操作
 */
export function getDialogDataForPage(active) {
    let data = []
    switch (active) {
        case "subject":
            // 编辑/科目
            data = [
                { title: "科目名称", type: "input", value: "", key: "name", isNotNull: true },
            ]
            break;


        default:
            break;
    }
    return data
}

export function getOptions(flag) {
    switch (flag) {
        case "topic":
            return [
                { label: "单选题", value: "0" },
                { label: "多选题", value: "1" },
                { label: "填空题", value: "2" },
                { label: "判断题", value: "3" },
                { label: "简答题", value: "4" },
            ]
            break;
        case "question":
            return [
                { label: "考试题库", value: "0" },
                { label: "练习题库", value: "1" },
                { label: "通用题库", value: "2" },
            ]
            break;

        default:
            break;
    }
}

/**
 * 初始化题库表格中的显示
 */
export function initTableValue(flag, value) {
    let array = getOptions(flag)
    let str = ""
    array.forEach(element => {
        if (element.value == value) {
            str = element.label
        }
    });
    return str
}